import { render, staticRenderFns } from "./RenderChildrens.vue?vue&type=template&id=2390afee&"
import script from "./RenderChildrens.vue?vue&type=script&lang=js&"
export * from "./RenderChildrens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports